export const meta = {
  id: 'O02', slug: 'convidar-usuario', title: 'Como convidar um usuário',
  description: 'Convide uma pessoa para o Personagrama e acompanhe seu primeiro acesso.',
  profile: 'owner', category: 'pessoas', type: 'task', status: 'published', order: 320,
  keywords: ['convite', 'convidar', 'usuário', 'primeiro acesso', 'membro'], previous: 'O01', next: 'O03',
  related: ['O01', 'G02'], updatedAt: '2026-08-17', appVersion: 'v1'
}

# Como convidar um usuário

O convite inicia a entrada de uma nova pessoa no ambiente Personagrama.

<HelpImage pendingId="O02.1" alt="Tela de convite de usuário" />

## Passo a passo

<Steps>
  <Step title="Abra Membros ou Convites">Acesse a área administrativa responsável por novos acessos.</Step>
  <Step title="Crie o convite">Informe os dados solicitados e, quando aplicável, o papel inicial.</Step>
  <Step title="Envie">Confirme o envio do convite.</Step>
  <Step title="Acompanhe o status">Verifique se a pessoa ainda está pendente ou se já concluiu o primeiro acesso.</Step>
</Steps>

<Callout type="tip">Depois da ativação, confirme se o papel e as associações necessárias estão corretos para a função da pessoa.</Callout>
